import {apiPost} from './api';

export default class ServicioLaboratorioDAO {
    static reporte(datos = {}) {
      return apiPost('/laboratorio/DAO/Reporte', datos);
    }

    static actualizarCampo(datos) {
        return apiPost("/laboratorio/DAO/ActualizarCampo", datos);
    }
    
    static validacionQA(datos) {
        return apiPost("/laboratorio/DAO/ValidacionQA", datos);
    }

    static validarMuestra(datos) {
        return apiPost("/laboratorio/DAO/validarMuestra", datos);
    }

    static preview(datos) {
        return apiPost("/laboratorio/DAO/Preview", datos);
    }

}
